import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import moment from "moment";
import { Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from "rxjs/operators";
import { IconCss, Icons, UserGroups } from "../../../assets/config/models";
import { CoreService } from "../../services/coreService";
import { CommonModule } from "@angular/common";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";

declare var toastr: any;

@Component({
    selector: "app-pos-machines",
    templateUrl: "./pos-machines.component.html",
    styleUrls: ["./pos-machines.component.scss"],
    standalone: true,
    imports: [FormsModule, CommonModule, NgxDatatableModule, ReactiveFormsModule]
})
export class PosMachinesComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  id;
  @Input()
  group;
  groupTypes = UserGroups;
  loading = []
  sortIcons = Icons;
  sortColumns = [];
  sorts = { prop: "", dir: "" };
  form: UntypedFormGroup;
  page = {
    //The number of elements in the page
    size: 0,
    //The total number of elements
    totalElements: 0,
    //The current page number
    pageNumber: 0,
  };
  icons = IconCss;
  iconsCss = {
    pagerLeftArrow: this.icons.left,
    pagerRightArrow: this.icons.right,
    pagerPrevious: this.icons.previous,
    pagerNext: this.icons.next,
  };
  isLoading = false;
  rows = [];
  machines$ = new Subject<{ offset: number }>();
  formChanges$;

  constructor(public coreService: CoreService, private builder: UntypedFormBuilder) {
    this.form = this.builder.group({
      mac_address: [""],
    });
    this.page.pageNumber = 0;
    this.page.size = 10;
    // this.machines$
    //   .pipe(
    //     tap((val) => {
    //       console.log(val);
    //       this.page.pageNumber = val.offset;
    //       this.isLoading = true;
    //     }),
    //     switchMap((val) => {
    //       return this.coreService.GetPOSMachines(
    //         {
    //           offset: this.page.pageNumber * this.page.size,
    //           limit: this.page.size,
    //         },
    //         this.form.controls,
    //         this.sorts,
    //         this.id
    //       );
    //     }),

    //     catchError((e) => {
    //       this.isLoading = false;
    //       return this.coreService.handleObservableError(e);
    //     })
    //   )
    //   .subscribe((response: any) => {
    //     this.rows = response.results;
    //     this.page.totalElements = response.count;
    //     this.isLoading = false;
    //     this.rows.forEach((data, index) => {
    //       this.loading[(this.page.size * this.page.pageNumber) + index] = false
    //     })

    //   });
    this.setSort();
  }

  resetFilters() {
    this.form.reset();
    this.sorts = { prop: "", dir: "" };
    this.setSort();
  }

  getIcon(prop) {
    return this.sortColumns.find((element) => element.prop == prop).icon;
  }

  setSort() {
    this.sortColumns = [];
    for (let key of Object.keys(this.form.value)) {
      this.sortColumns.push({
        prop: key,
        icon: this.sortIcons.none,
      });
    }
  }

  onSort(event) {
    console.log("event", event);
    this.sorts = event.sorts[0];
    this.setSort();
    let icon;
    switch (event.sorts[0].dir) {
      case "asc": {
        icon = this.sortIcons.asc;
        break;
      }
      case "desc": {
        icon = this.sortIcons.desc;
        break;
      }
      default: {
        icon = this.sortIcons.none;
        break;
      }
    }
    this.sortColumns.find(
      (element) => element.prop == event.sorts[0].prop
    ).icon = icon;
    this.machines$.next({ offset: 0 });
  }

  async ngOnInit() {
    this.formChanges$ = this.form.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((form) => {
        this.machines$.next({ offset: 0 });
      });
  }

  ngOnDestroy(): void {
    this.machines$.unsubscribe();
    this.formChanges$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.id.currentValue != null) {
      this.machines$.next({ offset: 0 });
    }
  }

  setLoading(index: number, value: boolean) {
    this.loading[(this.page.size * this.page.pageNumber) + index] = value
  }

  async activate(index: number, id: number) {
    this.setLoading(index, true)
    let form = {
      activated_on: moment(new Date()).format('DD-MM-YYYY HH:mm:ss'),
    };
    try {
      const activate = await this.coreService.ActivateOrDeactivateMachines(form, id).toPromise();
      if (activate) {
        this.setLoading(index, false)
        this.machines$.next({ offset: 0 })
        toastr.success("", "Machine activated successfully", {
          timeOut: 2000
        });
      }
    } catch {
      this.setLoading(index, false)
    } finally {
    }
  }

  async deActivate(index: number, id: number) {
    this.setLoading(index, true)
    let form = {
      activated_on: null
    };
    try {
      const deActivate = await this.coreService.ActivateOrDeactivateMachines(form, id).toPromise();
      if (deActivate) {
        this.setLoading(index, false)
        this.machines$.next({ offset: 0 })
        toastr.success("", "Machine deactivated successfully", {
          timeOut: 2000
        });
      }
    } catch {
      this.setLoading(index, false)
    } finally {
    }
  }
}
